/* =========================================================================
   Coffeetine — página de produto. Carregado só quando o template é product.

   O zero.js continua dono de tudo que é da loja: adicionar ao carrinho,
   abrir a gaveta, disparar o evento do pixel, acordeões e autoplay de
   vídeo. Aqui ficam só duas coisas da PDP:

     1. o rótulo do botão muda com o kit escolhido;
     2. a barra fixa do celular acompanha a escolha e aparece na hora certa.

   Nada aqui toca em URL, query string, UTM, gclid ou histórico (o ?caixas=
   que a home manda é lido pelo zero.js, uma vez, ao carregar).
   ========================================================================= */
(function () {
  'use strict';

  var buybox = document.querySelector('[data-pdp-buybox]');
  var barra = document.querySelector('[data-pdp-sticky]');
  if (!buybox) return;

  function texto(el, valor) {
    if (el && valor != null && el.textContent !== valor) el.textContent = valor;
  }

  function aplicar(card) {
    if (!card || !card.dataset.variantId) return;

    // O zero.js já cuida da classe .active, do rádio e do campo escondido.
    // Repetir aqui é barato e mantém a página em pé se ele falhar em carregar.
    var cards = buybox.querySelectorAll('[data-routine-card]');
    for (var i = 0; i < cards.length; i++) {
      var atual = cards[i] === card;
      cards[i].classList.toggle('active', atual);
      var radio = cards[i].querySelector('input[type="radio"]');
      if (radio) radio.checked = atual;
    }

    var campo = buybox.querySelector('[data-selected-variant]');
    if (campo) campo.value = card.dataset.variantId;
    // a mesma caixa em quantidade 1, 2 ou 3
    var qtd = buybox.querySelector('[data-selected-quantity]');
    if (qtd && card.dataset.quantity) qtd.value = card.dataset.quantity;

    var botao = buybox.querySelector('[data-product-buy]');
    if (botao && !botao.dataset.loading && card.dataset.pdpCta) {
      texto(botao, card.dataset.pdpCta + ' · ' + (card.dataset.pdpPrice || ''));
    }

    // parcela do kit no cartão
    // (o atributo do alvo é distinto do data-pdp-parcela dos cartões: o mesmo
    // seletor pegaria o primeiro cartão e apagaria o conteúdo dele)
    texto(buybox.querySelector('[data-pdp-parcela-alvo]'), card.dataset.pdpParcela);

    // barra fixa do celular: kit, preço, parcela e a variante do botão
    if (barra) {
      texto(barra.querySelector('[data-sticky-price]'), card.dataset.pdpPrice);
      texto(barra.querySelector('[data-sticky-doses]'), card.dataset.pdpDoses ? card.dataset.pdpDoses.toLowerCase() : '');
      texto(barra.querySelector('[data-sticky-parcela]'), card.dataset.pdpParcela);
      var cta = barra.querySelector('[data-sticky-add]');
      if (cta) {
        cta.dataset.variantId = card.dataset.variantId;
        cta.dataset.quantity = card.dataset.quantity || '1';
      }
    }
  }

  buybox.addEventListener('click', function (evento) {
    var card = evento.target.closest('[data-routine-card]');
    if (card) aplicar(card);
  });

  // teclado: o cartão é um <label> com rádio dentro, então a troca também
  // chega por setas sem passar por clique.
  buybox.addEventListener('change', function (evento) {
    if (evento.target.type !== 'radio') return;
    var card = evento.target.closest('[data-routine-card]');
    if (card) aplicar(card);
  });

  /* -------------------------------------------------------- barra fixa   */

  function ligarBarra() {
    if (!barra) return;

    var rodape = document.querySelector('.footer');
    // Enquanto o botão de compra de verdade estiver na tela, a barra some:
    // duas chamadas para a mesma ação ao mesmo tempo só atrapalham.
    var botao = buybox.querySelector('[data-product-buy]');
    var naTela = false;

    barra.hidden = false;

    function avaliar() {
      var noRodape = rodape
        ? rodape.getBoundingClientRect().top < window.innerHeight - 40
        : false;
      // Sem exigir rolagem: no celular o botão de verdade nasce abaixo da
      // primeira tela, e a barra é o que põe preço e compra à vista de cara.
      barra.classList.toggle('is-visible', !naTela && !noRodape);
    }

    if (botao && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(
        function (entradas) {
          naTela = entradas[0].isIntersecting;
          avaliar();
        },
        { rootMargin: '-40px 0px -120px 0px' }
      );
      observador.observe(botao);
    }

    avaliar();
    window.addEventListener('scroll', avaliar, { passive: true });
    window.addEventListener('resize', avaliar, { passive: true });
  }

  /* -------------------------------------------------- galeria: bolinhas */

  function ligarGaleria() {
    var galeria = document.querySelector('[data-galeria]');
    if (!galeria) return;
    var trilho = galeria.querySelector('[data-galeria-trilho]');
    var caixa = galeria.querySelector('[data-galeria-pontos]');
    if (!trilho || !caixa || trilho.children.length < 2) return;

    for (var i = 0; i < trilho.children.length; i++) {
      (function (idx) {
        var ponto = document.createElement('button');
        ponto.type = 'button';
        ponto.className = 'pdp-carrossel__ponto';
        ponto.setAttribute('aria-label', 'Imagem ' + (idx + 1));
        ponto.addEventListener('click', function () {
          trilho.scrollTo({ left: idx * trilho.clientWidth, behavior: 'smooth' });
        });
        caixa.appendChild(ponto);
      })(i);
    }

    function marcar() {
      var idx = Math.round(trilho.scrollLeft / trilho.clientWidth);
      for (var j = 0; j < caixa.children.length; j++) {
        caixa.children[j].classList.toggle('is-active', j === idx);
      }
    }
    trilho.addEventListener('scroll', marcar, { passive: true });
    window.addEventListener('resize', marcar, { passive: true });
    marcar();
  }

  function iniciar() {
    var inicial =
      buybox.querySelector('[data-routine-card].active') ||
      buybox.querySelector('[data-routine-card]');
    if (inicial) aplicar(inicial);
    ligarBarra();
    ligarGaleria();
  }

  // O zero.js também escreve no botão no DOMContentLoaded. Registrar sempre
  // nesse evento — e não chamar direto — garante que a última palavra seja
  // desta função, que é quem conhece os rótulos por kit.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    setTimeout(iniciar, 0);
  }
})();
